import { Box } from '@mui/material'
import { useEffect, useRef, useState } from 'react'

export default function ScrollFadeBox({ children }: any) {
  const scrollRef = useRef<HTMLDivElement>(null)
  const [isScrolled, setIsScrolled] = useState(false)
  const [isBottom, setIsBottom] = useState(false)

  useEffect(() => {
    const el = scrollRef.current
    if (!el) return

    const handleScroll = () => {
      setIsScrolled(el.scrollTop > 5)
      setIsBottom(el.scrollTop + el.clientHeight >= el.scrollHeight - 5)
    }

    // Check on mount and when content changes
    const resizeObserver = new ResizeObserver(() => {
      handleScroll()
    })

    resizeObserver.observe(el)
    handleScroll() // initialize on mount

    el.addEventListener('scroll', handleScroll)
    return () => {
      el.removeEventListener('scroll', handleScroll)
      resizeObserver.disconnect()
    }
  }, [])

  return (
    <Box
      ref={scrollRef}
      sx={{
        width: '100%',
        maxHeight: '30vh',
        overflowY: 'auto',
        borderRadius: '4px',
        position: 'relative',
        '& > *': {
          position: 'relative',
          zIndex: 0,
        },

        '&:before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '40px',
          background:
            'linear-gradient(to bottom, rgba(33, 32, 32, 0.95), transparent)',
          opacity: isScrolled ? 1 : 0,
          transition: 'opacity 0.3s ease',
          pointerEvents: 'none',
          zIndex: 1,
          display: 'block',
        },

        '&:after': {
          content: '""',
          position: 'sticky',
          bottom: '-1px',
          left: 0,
          right: 0,
          height: '40px',
          background:
            'linear-gradient(to top, rgba(220, 220, 220, 0.95), transparent)',
          opacity: isBottom ? 0 : 1,
          transition: 'opacity 0.3s ease',
          pointerEvents: 'none',
          zIndex: 1,
          display: 'block',
        },
      }}
    >
      {children}
    </Box>
  )
}
